export default __webpack_public_path__ + "img/consultation_approval-366354c308373feec68c60dabb9740e9.png";